import {
    cleanCommonParams,
    mapAttachmentsParams,
    mapTagsParams,
    mapContentParams,
    mapFeedItemParams,
    mapImageParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
} from './common';

const mapJobAidParams = (
    isCreate,
    {
        attachments,
        tags,
        categories,
        content,
        feed_item,
        image,
        productCategories,
        platforms,
        products,
        sales_channels,
        salesAndMarketingCategories,
        search_phrase_ids,
        states,
        systemCategories,
        expired_at,
        ...params
    },
) => {
    return new Promise((resolve) => {
        const categoryIds = [].concat(
            productCategories,
            salesAndMarketingCategories,
            systemCategories,
        );

        resolve({
            job_aid: {
                role_type: 'agent',
                ...cleanCommonParams(params),
                ...mapAttachmentsParams(isCreate, attachments),
                ...mapTagsParams(isCreate, tags),
                ...mapContentParams(isCreate, content),
                ...mapFeedItemParams(isCreate, feed_item),
                ...mapImageParams(isCreate, image),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapStatesParams(isCreate, states),
                category_ids: categoryIds,
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapJobAidParams };
